import React from "react";
import * as depgraph from "@snyk/dep-graph";
import { SnykCircularDepCounter } from "./SnykCircularDepCountersComponent";
import { Grid } from "@material-ui/core";
import { InfoCard } from "@backstage/core-components";
export const DepGraphInfo = ({ depGraph }) => {
    const snykGraph = depgraph.createFromJSON(depGraph.depGraph);
    const nodes = depGraph.depGraph.graph.nodes || [];
    const directDeps = nodes[0].deps || [];
    const indirectDeps = nodes
        .slice(1)
        .filter((node) => !directDeps.map((x) => x.nodeId).includes(node.nodeId));
    const directCount = directDeps.length;
    const indirectCount = indirectDeps.length;
    const totalCount = snykGraph.getPkgs().length - 1; // not counting rootPkg
    const depCount = {
        directCount: directCount,
        indirectCount: indirectCount,
        totalCount: totalCount,
    };
    return (React.createElement(InfoCard, null,
        React.createElement(Grid, { container: true, spacing: 2, justifyContent: "space-between", direction: "column" },
            React.createElement(Grid, { item: true },
                "Total Dependency count = ",
                totalCount,
                React.createElement("br", null)),
            React.createElement(Grid, { item: true },
                React.createElement(SnykCircularDepCounter, { depCount: depCount })))));
};
//# sourceMappingURL=SnykDepGraphComponent.js.map